import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import { withTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BotsCreators } from '../../store/actions/bots';

import './AvailableIa.scss';

import IntelligenceCardInfo from './component/IntelligenceCardInfo';

import Status from './Status/Status';
import Intencoes from './Intencoes/Intencoes';
import Entidades from './Entidades/Entidades';
import Condicoes from './Condicoes/Condicoes';
import Testar from './Testar/Testar';
import Aprimoramento from './Enhancement/Aprimoramento';
import Footer from '../Footer2';

function AvailableIa(props) {
  const [blt, setBlt] = useState('status');
  const localStorageData = JSON.parse(localStorage.getItem('visibleModals'));
  const [show, setShow] = useState(false);
  // const [show, setShow] = useState(
  //   !(localStorageData && localStorageData.videoIntel === 'suppress')
  // );
  const [isCheck, setIsCheck] = useState(false);

  const handleClose = () => {
    setShow(false);
    if (isCheck) {
      const localStorageData =
        JSON.parse(localStorage.getItem('visibleModals')) || {};
      localStorageData.videoIntel = 'suppress';
      localStorage.setItem('visibleModals', JSON.stringify(localStorageData));
    }
  };

  const handleCheckbox = () => {
    setIsCheck(!isCheck);
  };

  useEffect(() => {
    if (JSON.stringify(props.bot) === '{}')
      props.retrieveBotRequest(props.match.params.botid);
  }, []);
  return (
    <>
      <div className="linha-conteudo">
        <div className="conteudo-card">
          <div className="container-card-info">
            <IntelligenceCardInfo
              blt={blt}
              bot={props.bot}
              status={() => setBlt('status')}
              intencoes={() => setBlt('intencoes')}
              entidades={() => setBlt('entidades')}
              condicoes={() => setBlt('condicoes')}
              testar={() => setBlt('testar')}
              aprimoramento={() => setBlt('aprimoramento')}
            />
          </div>
          <div className="container-card">
            {blt === 'status' && <Status {...props} />}
            {blt === 'intencoes' && <Intencoes blt={blt} />}
            {blt === 'entidades' && <Entidades blt={blt} />}
            {blt === 'testar' && <Testar blt={blt} />}
            {blt === 'condicoes' && <Condicoes blt={blt} />}
            {blt === 'aprimoramento' && <Aprimoramento blt={blt} />}
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="modal-size"
        centered
        className="modal-content-ia"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="txt-title">
              Seja bem-vind@ à Inteligência Artificial da Boteria!
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-player">
            <div className="div-text">
              <p className="txt-subtitle" style={{ width: '100%' }}>
                Preparamos esse vídeo para ajuda-lo a entender os principais
                conceitos que encontrará por aqui:
              </p>
            </div>

            <video
              preload="auto"
              controls
              width="800px"
              height="450px"
              autoPlay={false}
            >
              <source
                src="https://storage.googleapis.com/boteria-videos/v-inteligencia.mp4"
                type="video/mp4"
              />
            </video>

            <div className="container-footer-video">
              <div
                className="checkbox-video"
                style={{ cursor: 'pointer' }}
                onClick={handleCheckbox}
              >
                <input type="checkbox" checked={isCheck} /> Não exibir este
                vídeo novamente
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="container-footer-find">
            <span>Ficou com alguma dúvida?</span>
            <a target="_BLANK" href="https://code7.com/faq/boteria/">
              <button className="btn-video">central de ajuda</button>
            </a>
          </div>
        </Modal.Footer>
      </Modal>
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  iaInfo: state.intelligence.iaInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AvailableIa))
);
